<template>
	<svg
		width="16"
		height="20"
		viewBox="0 0 16 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M2 20C1.44995 20 0.97937 19.8043 0.588013 19.413C0.196045 19.021 0 18.55 0 18V2C0 1.45001 0.196045 0.979004 0.588013 0.587006C0.97937 0.195679 1.44995 0 2 0H10L16 6V18C16 18.55 15.8043 19.021 15.413 19.413C15.021 19.8043 14.55 20 14 20H2ZM11 14.5C11 16.1569 9.65686 17.5 8 17.5C6.34314 17.5 5 16.1569 5 14.5C5 12.8431 6.34314 11.5 8 11.5C9.65686 11.5 11 12.8431 11 14.5ZM11 5.5H2V8.5H11V5.5Z"
			fill="black"
		/>
	</svg>
</template>

<script>
export default {
	name: "Save",
};
</script>
